module.exports = __webpack_public_path__ + "media/images/logo_icon_gray-670551cf446b88731c664f12a3485d23.svg";